// pages/Quizzer.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const Quizzer = () => (
  <>
    <title>Quizzer - Arthur Efremenko</title>
    <meta name="description" content={projects.quizzer.description} />
    <ProjectTemplate
      project={projects.quizzer}
      screenshots={projects.quizzer.screenshots}
    />
  </>
);

export default Quizzer;
